module.exports = __webpack_public_path__ + "img/industry-2.ab862273.jpg";